import { CheckAttributeLength, getTenReadableInnerText, numberToWords } from "../../utils";
import { ELEMENTS, HEADING_ELEMENTS, PARAMETER_EVENT, WIDGET_CLASS_ATTRIBUTES } from "../../utils/constants";


const useMultiFeatures = () => {

    //  RESET SETTINGS  //
    function resetSetting() {
        //  COLOR ADJUSTMENT  //
        localStorage.removeItem("rcp-dark-contrast");
        localStorage.removeItem("rcp-light-contrast");
        localStorage.removeItem("rcp-high-contrast");
        localStorage.removeItem("rcp-high-saturation");
        localStorage.removeItem("rcp-low-saturation");
        localStorage.removeItem("rcp-monoChrome-saturation");
        localStorage.removeItem("rcpColorState");
        localStorage.removeItem("rcpTitleColorState");
        localStorage.removeItem("rcpBgColorState");
        localStorage.removeItem("rcpTextColor");
        localStorage.removeItem("rcpTitleColor");
        localStorage.removeItem("rcpBgColor");

        //  CONTENT ADJUSTMENT  //
        localStorage.removeItem("rcp-readable-font");
        localStorage.removeItem("rcp-highlight-tile");
        localStorage.removeItem("rcp-highlight-links");
        localStorage.removeItem("rcp-text-align-center");
        localStorage.removeItem("rcp-textalign-left");
        localStorage.removeItem("rcp-textalign-right");
        localStorage.removeItem("rcp-text-magnifier");
        localStorage.removeItem("rcp-content-scaling");
        localStorage.removeItem("rcp-font-size");
        localStorage.removeItem("rcp-line-height");
        localStorage.removeItem("rcp-letter-spacing");

        //  ORIENTATION ADJUSTMENT  //
        localStorage.removeItem("rcp-highlight-hover");
        localStorage.removeItem("rcp-highLight-focus");
        localStorage.removeItem("rcp-black-cursor");
        localStorage.removeItem("rcp-white-cursor");
        localStorage.removeItem("rcp-hide-image");
        localStorage.removeItem("rcp-reading-guide-curser");
        localStorage.removeItem("rcp-mute-sound");
        localStorage.removeItem("rcp-animations-stop");
        localStorage.removeItem("rcp-reading-mask");
        localStorage.removeItem("rcp-read-mode");

        //  PROFILE ADJUSTMENT  //
        localStorage.removeItem("rcp-seizure-safe-profile");
        localStorage.removeItem("rcp-vision-impaired-profile");
        localStorage.removeItem("rcp-adhd-friendly-profile");
        localStorage.removeItem("rcp-cognitive-disability-profile");
        localStorage.removeItem("rcp-blind-user-screen-reader");
        localStorage.removeItem("rcp-over-size-widget");
        localStorage.removeItem("rcp-dylexic-font");
        localStorage.removeItem("rcp-keyboard-navigation");

        window.location.reload();
    }

    //  hide interface  //
    function hideInterFace() {
        let getIdHideInterFace = document.getElementById("hideInterFacePopUp");
        if (getIdHideInterFace.style.display === "flex") {
            getIdHideInterFace.style.display = PARAMETER_EVENT.NONE;
        } else {
            getIdHideInterFace.style.display = "flex";
        }
    }
    function hideInterFaceNone() {
        document.getElementById("progatixWidget").style.display = PARAMETER_EVENT.NONE;
        localStorage.setItem("progatixWidget", PARAMETER_EVENT.CLOSE);
    }
    //  HANDLE GLOBAL CONSTIONS  //

    // Function Handle same href attibute and diferent aria-label  //
    function getDuplicateHrefs(selector) {
        // Select elements based on the provided selector
        const links = document.querySelectorAll(selector);

        const hrefMap = {};

        links.forEach(link => {
            const hrefValue = link.getAttribute('href');
            const ariaLabel = link.getAttribute('aria-label') || 'No aria-label';

            if (!hrefMap[hrefValue]) {
                hrefMap[hrefValue] = { 'No aria-label': [], 'Aria-labels': [] };
            }

            if (ariaLabel === 'No aria-label') {
                hrefMap[hrefValue]['No aria-label'].push(link);
            } else {
                hrefMap[hrefValue]['Aria-labels'].push(ariaLabel);
            }
        });

        for (const href in hrefMap) {
            const noAriaLabelElements = hrefMap[href]['No aria-label'];
            const ariaLabels = hrefMap[href]['Aria-labels'];

            const ariaLabelCounts = {};
            ariaLabels.forEach(label => {
                ariaLabelCounts[label] = (ariaLabelCounts[label] || 0) + 1;
            });

            const uniqueAriaLabels = Object.keys(ariaLabelCounts);

            if (uniqueAriaLabels.length === 1) {
                const commonAriaLabel = uniqueAriaLabels[0];
                if (noAriaLabelElements.length > 0) {
                    // console.log(`Applying aria-label="${commonAriaLabel}" to elements with href="${href}" that currently have no aria-label.`);
                    noAriaLabelElements.forEach(element => {
                        element.setAttribute('aria-label', commonAriaLabel);
                        // console.log('element',element);
                    });
                }
            } else {
                // console.log(`href="${href}" has multiple aria-labels or no aria-labels to apply.`);
            }
        }
    }
    //  Handle Aria Label Attribute  //
    function handleAnchorButton(element) {

        if (element.nodeName === ELEMENTS.A || element.nodeName === ELEMENTS.BUTTON) {
            let ariaLabel = element.getAttribute("aria-label");
            let title = element.getAttribute("title");
            let target = element.getAttribute("target");
            let href = element.getAttribute("href");
            const hashPattern = /\bai_[a-z0-9]+\b|\b\d+\b/gi;
            let finalInnerTextString = element.innerText;
            const cleanString = str => str?.replace('&', 'and')?.replace(/\b\d+\b/g, (match) => numberToWords(parseInt(match)))?.replace(/[-_:"']/g, ' ')?.replace(hashPattern, '')?.trim();
            const formats = ["tel:", "ph:", "facetime:", "sms:", "https://wa.me/", "mailto:", "mob:", "sky:"];
            if (finalInnerTextString && !formats.some(format => finalInnerTextString.toLowerCase().includes(format))) {
                if (href && formats.some(format => href.toLowerCase().includes(format))) {
                    const matchedFormat = formats.find(format => href.toLowerCase().includes(format));
                    finalInnerTextString = `${matchedFormat + finalInnerTextString}`;
                } 
                // else {
                //     finalInnerTextString = getTenReadableInnerText(finalInnerTextString);
                //     // finalInnerTextString = cleanString(finalInnerTextString);
                // }
            }


            if (title && !formats.some(format => title.toLowerCase().includes(format))) {
                title = cleanString(title);
            }

            function checkTargetTabWarningAndSetAriaLabel(ariaLabel, value) {
                if (target === "_blank" && !ariaLabel?.includes(WIDGET_CLASS_ATTRIBUTES.NEW_TAB_WARNING)) { //WCAG 2.1 Guideline 3.2.2
                    element.setAttribute("aria-label", `${value} ${WIDGET_CLASS_ATTRIBUTES.NEW_TAB_WARNING}`);
                    // console.log('complaince fulfill by widget with target_blank warning and fulfil with innerText', value, element);
                } else {
                    element.setAttribute("aria-label", `${value}`)
                    // console.log('complaince fulfill by widget fulfil with innerText', value, element)
                }
            }


            if (!ariaLabel || ariaLabel === null || ariaLabel?.trim() === '') {
                if (finalInnerTextString && finalInnerTextString !== null && finalInnerTextString.trim() !== '') {
                    checkTargetTabWarningAndSetAriaLabel(ariaLabel, finalInnerTextString);
                } else if (title !== undefined && title !== null) {
                    checkTargetTabWarningAndSetAriaLabel(ariaLabel, title);
                } else if (element.nodeName === ELEMENTS.A && href?.trim() !== '' && !href?.includes(WIDGET_CLASS_ATTRIBUTES.HREF_JS_VOID)) {
                    if (href?.includes('#')) {
                        if (href === '#' || href === WIDGET_CLASS_ATTRIBUTES.HREF_JS_VOID) {
                            // console.log(`Please Remove Extra ${element.nodeName} tag`, element)
                        } else {
                            let stringAfterHash = href.split('#')[1];
                            let matchValue = document.getElementById(stringAfterHash)
                            if (matchValue) {
                                for (let heading of ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']) {
                                    let headingElement = matchValue.querySelector(heading);
                                    if (headingElement && headingElement !== null && headingElement !== undefined) {
                                        // let headingElementInnerText = cleanString(headingElement.innerText);
                                        let headingElementInnerText = headingElement.innerText;
                                        if (headingElementInnerText && headingElementInnerText !== null && headingElementInnerText.trim() !== '') {
                                            checkTargetTabWarningAndSetAriaLabel(ariaLabel, headingElementInnerText);
                                        }
                                        break;
                                    } else {
                                        // console.log("please add aria-label:", element);
                                    }
                                }
                            } else {
                                // console.log("please add aria-label:", element);
                            }
                        }
                    }
                } else {
                    // console.log("please add aria-label:", element);
                }
            }
            else {
                if (ariaLabel && !formats.some(format => ariaLabel.toLowerCase().includes(format))) {
                    if (ariaLabel?.includes(WIDGET_CLASS_ATTRIBUTES.NEW_TAB_WARNING)) {
                        ariaLabel?.replace(WIDGET_CLASS_ATTRIBUTES.NEW_TAB_WARNING, " ");
                    }
                    // if (CheckAttributeLength(ariaLabel, element) > 10) {
                    //     ariaLabel = getTenReadableInnerText(ariaLabel);
                    // }
                    // ariaLabel = cleanString(ariaLabel);
                }

                if (target === "_blank" && !ariaLabel?.includes(WIDGET_CLASS_ATTRIBUTES.NEW_TAB_WARNING)) {
                    element.setAttribute("aria-label", `${ariaLabel} ${WIDGET_CLASS_ATTRIBUTES.NEW_TAB_WARNING}`);
                    // console.log('complaince fulfill by widget with target_blank warning and fulfil with href id', element);
                } else if (ariaLabel?.trim() === WIDGET_CLASS_ATTRIBUTES.NEW_TAB_WARNING) {

                    if (finalInnerTextString && finalInnerTextString !== null && finalInnerTextString.trim() !== '') {
                        element.setAttribute("aria-label", `${finalInnerTextString} ${WIDGET_CLASS_ATTRIBUTES.NEW_TAB_WARNING}`);
                        // console.log('complaince fulfill by widget with target_blank warning and fulfil with innerText', finalInnerTextString, element);
                    } else if (title && title !== undefined && title !== null) {
                        checkTargetTabWarningAndSetAriaLabel(ariaLabel, title);
                    } else if (element.nodeName === ELEMENTS.A && href?.trim() !== '' && !href?.includes(WIDGET_CLASS_ATTRIBUTES.HREF_JS_VOID)) {
                        if (href?.includes('#')) {
                            if (href === '#' || href === WIDGET_CLASS_ATTRIBUTES.HREF_JS_VOID) {
                                // console.log(`Please Remove Extra ${element.nodeName} tag`, element)
                            } else {
                                let stringAfterHash = href.split('#')[1];
                                let matchValue = document.getElementById(stringAfterHash)
                                if (matchValue) {
                                    for (let heading of ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']) {
                                        let headingElement = matchValue.querySelector(heading);
                                        if (headingElement && headingElement !== undefined && headingElement !== null) {
                                            // let headingElementInnerText = cleanString(headingElement.innerText);
                                            let headingElementInnerText = headingElement.innerText;
                                            if (headingElementInnerText && headingElementInnerText !== null && headingElementInnerText.trim() !== '') {
                                                checkTargetTabWarningAndSetAriaLabel(ariaLabel, headingElementInnerText);
                                            }
                                            break;
                                        } else {
                                            // console.log("please add aria-label:", element);
                                        }
                                    }
                                } else {
                                    // console.log("please add aria-label:", element);
                                }
                            }
                        } else if (href === WIDGET_CLASS_ATTRIBUTES.HREF_JS_VOID) {
                            // console.log("please convert A tag to BUTTON tag", element)
                        } else {
                            // console.log("please add aria-label:", element);
                        }
                    } else {
                        // console.log("please add readable aria-label:", element);
                    }
                } 
                else {
                    if (ariaLabel !== null) {
                        element.setAttribute("aria-label", ariaLabel);
                    }
                    // console.log('already fix complaince:', element)
                }
            }

            if ((!href || href === null || href.trim() === '' || href === WIDGET_CLASS_ATTRIBUTES.HREF_JS_VOID || href === "#") && element.nodeName === ELEMENTS.A) {
                // console.log(`Please Remove Extra ${element.nodeName} tag`, element)
            }

            //  Handle Nested Button and Redirect Elements  //
            for (let i = 0; i < element.childNodes.length; i++) {
                if (element.childNodes[i].nodeName === ELEMENTS.A || element.childNodes[i].nodeName === ELEMENTS.BUTTON) {
                    // console.log('An <a> (link) element has been detected within a <button> element or a <button> element has been detected within an <a> (link) element ', element.childNodes[i]);
                }
            }
        }
    }
    //  Handle Iframe or Frame Elements  //
    function handleIframeOrFrameElements(element) {
        if (element.nodeName === ELEMENTS.IFRAME || element.nodeName === ELEMENTS.FRAME) {
            let title = element.getAttribute("title");
            let ariaHidden = element.getAttribute("aria-hidden");
            if (!title || title === null || title.trim() === '') {
                // console.log('warning: please add readable title attribute', element);
                element.setAttribute("title", "title");
                if (!ariaHidden) {
                    element.setAttribute("aria-hidden", "true");
                    // console.log('Mishandled decorative title', element);
                }
            }
        }
    }
    //  Handle Sucture Issues and Throw warning  //
    function handleStuctureIssues(element) {
        //  Handle fieldset element: check first child legend element is Required  //
        if (element.nodeName === ELEMENTS.FIELDSET) {
            if (element.firstElementChild && element.firstElementChild.nodeName === ELEMENTS.LEGEND) {
                // console.log("First child is a LEGEND element", element);
            } else {
                let legend = document.createElement("legend");
                legend.innerText = element.innerText.trim() ? element.innerText.trim() : "legend";
                legend.style.display = PARAMETER_EVENT.NONE;
                element.insertBefore(legend, element.firstChild);
                // console.log("First child is not a LEGEND element", element);
            }
        }
        //  Handle Element lacks semantic markup I element and B element  //
        else if (element.nodeName === ELEMENTS.I) {
            if (element.innerText.trim() !== "") {
                // console.log('Element lacks semantic markup i element convert to em element', element);
                // structureChangeWithStyle(element, 'em');
            }
        }
        else if (element.nodeName === ELEMENTS.B) {
            // console.log('Element lacks semantic markup b element convert to strong element', element);
            // structureChangeWithStyle(element, 'strong');
        }
        //  Handle List group lacks any list items  //
        else if (element.nodeName === ELEMENTS.UL || element.nodeName === ELEMENTS.OL || element.nodeName === ELEMENTS.DL || element.nodeName === ELEMENTS.DD) {
            if (element.childNodes.length > 0) {
                let hasOnlyTextNodes = true;
                for (let j = 0; j < element.childNodes.length; j++) {
                    if (element.childNodes[j].nodeType !== Node.TEXT_NODE) {
                        hasOnlyTextNodes = false;
                        break;
                    }
                }
                if (hasOnlyTextNodes) {
                    // console.log(`${element.nodeName} Either remove the list group element (<ol>, <ul>, or <dl>) or populate it with list item elements (<li> or <dt>, respectively). For example: <ul><li>Apples</li><li>Oranges</li></ul>.`, element);
                } else {
                    for (let j = 0; j < element.childNodes.length; j++) {
                        if (element.childNodes[j].nodeType === Node.ELEMENT_NODE) {
                            if ((element.nodeName === ELEMENTS.UL || element.nodeName === ELEMENTS.OL) && element.childNodes[j].nodeName !== ELEMENTS.LI) {
                                //  console.log(`${element.nodeName} has but not correct list items (LI) for UL /OL`, element);
                                break;
                            } else if (element.nodeName === ELEMENTS.DL && element.childNodes[j].nodeName !== ELEMENTS.DT && element.nodeName === ELEMENTS.DD && element.childNodes[j].nodeName !== ELEMENTS.DD) {
                                // console.log(`${element.nodeName} has but not correct list items  (DT/DD) for DL`, element);
                                break;
                            } else {
                                // console.log(`${element.nodeName} contains children correct list items`, element);
                            }
                        }
                    }
                }
            } else {
                //  console.log(`${element.nodeName} Either remove the list group element (<ol>, <ul>, or <dl>) or populate it with list item elements (<li> or <dt>, respectively). For example: <ul><li>Apples</li><li>Oranges</li></ul>.`, element);
            }
        }
        //  Hanlde List item lacks parent list wrapper  //
        else if (element.nodeName === ELEMENTS.LI) {
            if (element.parentElement.nodeName === ELEMENTS.UL || element.parentElement.nodeName === ELEMENTS.OL) {
                // console.log(`${element.nodeName} parent is correct`, element.parentElement)
            } else {
                // console.log(`${element.nodeName} parent is incorrect`, element.parentElement)
            }
        }
        else if (element.nodeName === ELEMENTS.DD || element.nodeName === ELEMENTS.DT) {
            if (element.parentElement.nodeName === ELEMENTS.DL) {
                //  console.log(`${element.nodeName} parent is correct`, element.parentElement)
            } else {
                // console.log(`${element.nodeName} parent is incorrect`, element.parentElement)
            }
        }
    }
    //  Handle input tag or Textarea tag aria-label attribute  //
    function handleInputTextareaElements(element) {
        if (element.nodeName === ELEMENTS.INPUT || element.nodeName === ELEMENTS.TEXTAREA) {
            let ariaLabel = element.getAttribute("aria-label");
            let placeholder = element.getAttribute("placeholder");
            let type = element.getAttribute("type");

            if ((!ariaLabel || ariaLabel === null || ariaLabel.trim() === '') && type !== "hidden") {
                let inputId = element.getAttribute("id");
                if (inputId) {
                    let label = document.querySelector(`label[for="${inputId}"]`);
                    if (label) {
                        element.setAttribute("aria-label", label.innerText);
                        // console.log(`fix by widget this ${element.nodeName}: add aria-label with label text`, element);
                    } else if (placeholder) {
                        element.setAttribute("aria-label", placeholder);
                        // console.log(`fix by widget this ${element.nodeName}: add aria-label with placeholder`, element);
                    } else {
                        // console.log(`pleace fix this ${element.nodeName}: add aria-label`, element);
                    }
                } else if (placeholder) {
                    element.setAttribute("aria-label", placeholder);
                    // console.log(`fix by widget this ${element.nodeName}: add aria-label with placeholder`, element);
                } else {
                    // console.log(`pleace fix this ${element.nodeName}: add aria-label`, element);
                }
            }
        }
    }
    //  Handle Empty Id  //
    function handleEmptyIds(element) {
        let id = element.getAttribute("id");
        if ((id?.trim() === '')) {
            element.removeAttribute("id");
            // console.log(`Compliance fullfil by widget remove empty id attibutes id attribute ${element.nodeName}`, element);
        }
    }
    //  Handle custom buttons make readable and keyboard navigation friendly  //
    function handleCustomButtons(element) {
        const role = element.getAttribute("role");
        if (role === "button") {
            const tabindex = element.getAttribute("tabindex");
            if (!tabindex) {
                element.setAttribute("tabindex", 0);
            }
            let ariaLabel = element.getAttribute("aria-label");
            if ((!ariaLabel || ariaLabel === null || ariaLabel.trim() === '') && element.innerText && getTenReadableInnerText(element.innerText) !== undefined && getTenReadableInnerText(element.innerText) !== null) {
                element.setAttribute("aria-label", getTenReadableInnerText(element.innerText));
                //  console.log('complaince fulfill by widget add aria-label or tabindex', element);
            }
        }
    }
    // Function to check for duplicate IDs //
    function checkForDuplicateIDs() {
        const elements = document.querySelectorAll('*'); // Get all elements
        const idArray = []; // Array to store IDs
        const idMap = new Map(); // Map to keep track of occurrences

        // Collect all IDs into an array
        elements.forEach((element) => {
            const id = element.id;
            if (id) {
                idArray.push(id);
            }
        });

        // Check for duplicates
        idArray.forEach((id) => {
            if (idMap.has(id)) {
                idMap.set(id, idMap.get(id) + 1); // Increment count for duplicate ID
            } else {
                idMap.set(id, 1); // Initialize count for new ID
            }
        });

        // Highlight or log duplicate IDs
        idMap.forEach((count, id) => {
            if (count > 1) {
                // Optionally, highlight elements with duplicate IDs
                elements.forEach((element) => {
                    if (element.id === id) {
                        // console.log('please fix is issue remove dublicate ids', element)
                    }
                });
            }
        });
    }
    //  Heading Sequence Check  // 
    function checkHeadingSequence() {
        const headings = document.querySelectorAll(HEADING_ELEMENTS);
        let lastLevel = null;
        let h1Count = 0;
        let h1Elements = [];
        let h1FollowedByH2 = false;

        headings.forEach((heading, index) => {
            const currentLevel = parseInt(heading.tagName.substring(1), 10);
            const isSectionMainHeading = heading.closest('section') && !heading.previousElementSibling;

            // Count h1 tags and store them
            if (currentLevel === 1) {
                h1Count++;
                h1Elements.push(heading);
                h1FollowedByH2 = false; // Reset the flag whenever a new h1 is encountered
            }

            // Check if the first heading is not an h1
            if (index === 0 && currentLevel !== 1) {
                // console.warn(`Structure warning: The first heading is <${heading.tagName}> instead of <h1>.`, heading);
                // structureChangeWithStyle(heading, 'h1');
            }

            // Check if the current heading level is greater than the last level + 1
            if (lastLevel !== null && currentLevel > lastLevel + 1) {
                // console.warn(`Structure warning: <${heading.tagName}> is out of order after <h${lastLevel}>.`, heading);

                // If h1 was followed by h2, convert any subsequent out-of-sequence headings to h3
                if (h1FollowedByH2) {
                    // structureChangeWithStyle(heading, 'h3');
                } else {
                    let selectElement = heading.tagName === ELEMENTS.H1 ? ELEMENTS.H3 : heading.tagName === ELEMENTS.H2 ? ELEMENTS.H3 : heading.tagName === ELEMENTS.H3 ? ELEMENTS.H4 : heading.tagName === ELEMENTS.H4 ? ELEMENTS.H5 : heading.tagName === ELEMENTS.H5 ? ELEMENTS.H6 : `h${lastLevel + 1}`;
                    // lastLevel !== 6 && structureChangeWithStyle(heading, selectElement);
                }
            }

            // Track if h1 is followed by h2
            if (currentLevel === 2 && lastLevel === 1) {
                h1FollowedByH2 = true;
            }

            // Ensure the main heading of each section is h2
            if (isSectionMainHeading && currentLevel !== 2) {
                // console.warn(`Structure warning: The main heading of the section is <${heading.tagName}> instead of <h2>.`, heading);
                // structureChangeWithStyle(heading, 'h2');
            }

            lastLevel = currentLevel;
        });

        // Warn if there is more than one h1 and print all h1 elements
        if (h1Count > 1) {
            // console.warn(`Structure warning: There are ${h1Count} <h1> tags on this page. Only one <h1> should be used.`);
            h1Elements.forEach((h1, index) => {
                if (index !== 0) {
                    // structureChangeWithStyle(h1, 'h3');
                }
                //  console.log('h1 ', h1);
            });
        }
    }

    //  Handle Images empty alt attribute and length alt attribute issue //
    let altAttributes = {};
    function handleImageAlt(elements) {
        if (elements.nodeName === ELEMENTS.IMG) {

            let alt = elements.getAttribute("alt");
            const src = elements.getAttribute("src");

            const hashPattern = text => /\bai_[a-z0-9]+\b|\b\d+\b/gi.test(text);
            // const hashPattern = /\bai_[a-z0-9]+\b|\b\d+\b/gi;
            const fileExtensionPattern = /\b(?:jpg|jpeg|png|gif|bmp|webp|svg)\b/gi;

            const isReadable = text => /^[a-zA-Z\s\(\)\.\'"]+$/.test(text);
            const hasUnwantedSpecialChars = text => /[^a-zA-Z\s\(\)\.\'"]/.test(text);

            const cleanString = str => str.replace(/[-_:"']/g, '').replace(fileExtensionPattern, '').replace(/\b\d+\b/g, (match) => numberToWords(parseInt(match))).trim();
            // const cleanString = str => str.replace(/[-_:"']/g, '').replace(hashPattern, '').replace(fileExtensionPattern, '').trim();

            const extraneousNames = /images|image|photos|photo|graphics|graphic|illustrations|illustration|icons|icon|logos|logo/gi;

            const cleanExtraneousText = str => str.replace(extraneousNames, '').trim();

            const removeDoubleSpaces = str => str.replace(/\s\s+/g, ' ');

            if (!alt || alt.trim() === '') {
                let words = src.match(/\b\w+\b/g);
                let lastFiveWords = (words && words.length > 0) ? words.slice(-5).join(" ") : "";
                let cleanedAlt = cleanString(lastFiveWords);
                if (cleanedAlt === '' || !isReadable(cleanedAlt) || hasUnwantedSpecialChars(cleanedAlt)) {
                    const ariaHidden = elements.getAttribute("aria-hidden");
                    if (!alt) {
                        elements.setAttribute("alt", "");
                    }
                    if (!ariaHidden) {
                        elements.setAttribute("aria-hidden", "true");
                        // console.log('Mishandled decorative image', elements);
                    }
                    // console.log('Please remove special characters and ensure the alt attribute value is meaningful and readable:', elements);
                } else {
                    cleanedAlt = removeDoubleSpaces(cleanedAlt);
                    elements.setAttribute("alt", cleanedAlt);
                }
            } else {
                // alt = cleanString(alt);
                if (!isReadable(alt) || hasUnwantedSpecialChars(alt)) {
                    const ariaHidden = elements.getAttribute("aria-hidden");
                    if (!alt) {
                        elements.setAttribute("alt", "");
                    }
                    if (!ariaHidden) {
                        elements.setAttribute("aria-hidden", "true");
                        // console.log('Mishandled decorative image', elements);
                    }
                    // console.log('Please remove special characters and ensure the alt attribute value is meaningful and readable:', elements);
                } else {
                    alt = removeDoubleSpaces(alt);
                    elements.setAttribute("alt", alt);
                   let altWords = alt.match(/\b\w+\b/g);
                    if (altWords && altWords.length > 10) {
                        // console.log("Alt attribute should be between 5 and 10 words", elements);
                    }
                }
                if (extraneousNames.test(alt)) {
                    let cleanedExtraneousText = cleanExtraneousText(alt);
                    cleanedExtraneousText = removeDoubleSpaces(cleanedExtraneousText);
                    elements.setAttribute("alt", cleanedExtraneousText);
                }
                // Check and print duplicates
                if (altAttributes[alt]) {
                    altAttributes[alt].push(elements);
                    if (altAttributes[alt].length === 2) {
                        // Print all duplicates when encountering the second occurrence
                        // console.log('Duplicate alt attribute:', alt);
                        altAttributes[alt].forEach((elem, index) => {
                            //  console.log('Write each images attribute to uniquely describe that images meaning or purpose.', elem)
                            elem.setAttribute("alt", alt + " " + numberToWords(index));
                            //  console.log('Handle Dublicates Alt attribute', elem)
                        });
                    }
                } else {
                    altAttributes[alt] = [elements];
                }
            }
        }
    }

    return { resetSetting, hideInterFaceNone, hideInterFace, handleAnchorButton, getDuplicateHrefs, handleIframeOrFrameElements, handleStuctureIssues, handleInputTextareaElements, handleEmptyIds, handleCustomButtons, checkForDuplicateIDs, checkHeadingSequence, handleImageAlt }

}

export default useMultiFeatures